// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"530":"page","820":"serviceList","945":"dashboard"}[chunkId] || chunkId) + "." + {"91":"d2a5175f","530":"835c1866","820":"f9ebb706","945":"e2f70c9b"}[chunkId] + ".js";
};